import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

export const StyledPaper = styled(Paper)(({ theme }) => ({
	padding: '8%',
	backgroundColor: '#f8fafc',
	border: '1px solid',
	borderColor: '#eeeeee',
	borderRadius: '8px'
}));
